import React from 'react';
import './App.css'
import { Route, Switch, HashRouter, BrowserRouter } from 'react-router-dom'

import * as firebase from "firebase/app"

import Home from './views/Home/Home'
import Dashboard from './views/Dashboard/Dashboard'
import Payge from './views/Payge/Payge'
import ProPayge from './views/ProPayge/ProPayge'
import Creator from './views/Creator/Creator'
import CollectionPayge from './views/CollectionPayge/CollectionPayge'
import CreatorCollection from './views/Creator/CreatorCollection/CreatorCollection';
import CreatorStandard from './views/Creator/CreatorStandard/CreatorStandard';
import CreatorPro from './views/Creator/CreatorPro/CreatorPro';

// Firebase setup

const firebaseConfig = {
  apiKey: "AIzaSyDrDdmRMzPZdInG6O9uTVrfslh82gXBcAc",
  authDomain: "paygeio.firebaseapp.com",
  databaseURL: "https://paygeio.firebaseio.com",
  projectId: "paygeio",
  storageBucket: "paygeio.appspot.com",
  messagingSenderId: "678604044547",
  appId: "1:678604044547:web:36eb96ef1cc917ff639136",
  measurementId: "G-VQ4G5MMTPL"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

function App() {
	return (
		<BrowserRouter>
			<Switch>
				<Route exact path="/" name="Payge" component={ Home } />
				<Route exact path="/dashboard" name="Payge Dashboard" component={ Dashboard } />
				<Route exact path="/creator" name="Payge Creator" component={ Creator } />
				<Route exact path="/creator/standard" name="Payge Creator" component={ CreatorStandard } />	
				<Route exact path="/creator/pro" name="Payge Creator" component={ CreatorPro } />	
				<Route exact path="/creator/collection" name="Payge Creator" component={ CreatorCollection } />	
				{/* <Route exact path="/download" name="Download Payge" component={ Payge } /> */}
				<Route exact path="/:payge_id" name="Download Payge" component={ Payge } />
				<Route exact path="/pro/:payge_id" name="Download Payge" component={ ProPayge } />
				<Route exact path="/collection/:payge_id" name="Download Payge" component={ CollectionPayge } />
			</Switch>
		</BrowserRouter>
	)
}

export default App